import { motion } from 'framer-motion';

const Transportation = () => {
  return (
    <section className="py-16 px-4 bg-rose-50">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="text-center"
        >
          {/* Kutipan dalam Bahasa Sanskerta */}
          <div className="mb-8">
            <h3 className="font-great-vibes text-3xl md:text-4xl text-rose-600 mb-4">
              Autobuses
            </h3>
            <p className="text-gray-500 italic">
              Pondremos autobuses para que podáis desplazaros el día de la boda, tanto a la ida como a la vuelta.
              <br></br>
            </p>
            <p className="text-gray-500 italic">
              Iremos publicando aquí las horas y trayectos de los autobuses más adelante.
            </p>
          </div>

          {/* Garis pemisah dekoratif */}
          <div className="flex items-center justify-center mb-8">
            <div className="h-px bg-rose-200 w-16"></div>
            <div className="mx-4 text-rose-400">✻</div>
            <div className="h-px bg-rose-200 w-16"></div>
          </div>

          {/* Kutipan dari Al-Qur'an */}
          <div>
            <h3 className="font-great-vibes text-3xl md:text-4xl text-rose-600 mb-4">
              Ave
            </h3>
            <p className="text-gray-600">Los horarios y precios del ave ya están disponibles en la página de renfe.</p>
            <p className="text-gray-500"><br></br>En ave tenéis la posibilidad de viajar el mismo sábado por la mañana prontito.</p>
          </div>
        </motion.div>

        {/* Elemen dekoratif */}
        <div className="flex justify-center mt-12 space-x-4">
          {[1, 2, 3].map((item) => (
            <motion.div
              key={item}
              animate={{ y: [0, -10, 0] }}
              transition={{
                repeat: Infinity,
                duration: 2,
                delay: item * 0.3
              }}
              className="text-rose-400 text-xl"
            >
              ✽
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Transportation;